import React,{useRef,useEffect} from 'react';
import useFilterElement from 'react-filter-element';
import './FilterSample.css';





function FilterSample({home}) {

const parent = useRef(null);
const [filter,items] = useFilterElement(parent);

useEffect(() => {
	console.log(items)
}, [items])


	return (
		
		<div className="services" id="services">
			<div className="serviceHeader text-center pt-4">
				<h1 className="sectionTitle bold">React Filter Element</h1>
			</div>
			<div className="serviceContent pt-5 pb-5">
		<div className="filerButtonContainer text-center">
			<button className="btn filterBtn" onClick={() => filter('*')}>All</button>
			<button className="btn filterBtn" onClick={() => filter('bird')}>Birds</button>
			<button className="btn filterBtn" onClick={() => filter('fish')}>Fishes</button>
			<button className="btn filterBtn" onClick={() => filter('android')}>Android</button>
			<button className="btn filterBtn" onClick={() => filter('iphone')}>Iphone</button>
		</div>
	
  
			<div className="row p-5 justify-content-center itemsContainer text-center" ref={parent}>
				   
				<div className="card col-3 p-2 m-2 bird">
					<h1 className="card-title">Bird</h1>
				</div>
			   
				<div className="card col-3 p-2 m-2 iphone">
					<h1 className="card-title">Iphone</h1>
				</div>
   
				<div className="card col-3 p-2 m-2 android">
					<h1 className="card-title">Android</h1>
				</div>
			   
				<div className="card col-3 p-2 m-2 android">
					<h1 className="card-title">Android</h1>
				</div>	

				<div className="card col-3 p-2 m-2 fish">
					<h1 className="card-title">Fish</h1>
				</div>	

				<div className="card col-3 p-2 m-2 fish">
					<h1 className="card-title">Fish</h1>
				</div>

				<div className="card col-3 p-2 m-2 iphone">
					<h1 className="card-title">Iphone</h1>
				</div>	


				<div className="card col-3 p-2 m-2 fish">
					<h1 className="card-title">Fish</h1>
				</div>						   
				
			</div>


				
			</div>
		</div>
	)
}

export default FilterSample;


